module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/alien.png?21d43e97a9093d14ea461ef7b3194402";